import React, { memo } from 'react';

import { Svg } from '@lglp/components';

function BreadcrumbIcon({ className, ...rest }) {
  return (
    <Svg
      className={['breadcrumb-icon', className]}
      viewBox="0 0 10 10"
      {...rest}
    >
      <path d="M1 1 L8 5 L1 9" />
    </Svg>
  );
}

export default memo(BreadcrumbIcon);
